import { useQuery } from '@tanstack/react-query';
import { getLiveSimulations } from '../../queries/LiveSimulations';

function useFetchLiveSimulations(origin: string) {
  const { data, isError, error, isSuccess, isPending, refetch } = useQuery({
    queryKey: ['live-classes-simulations', origin],
    queryFn: () => getLiveSimulations(origin),
    retry: false,
    refetchOnWindowFocus: false
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    refetch,
  };
}

export { useFetchLiveSimulations };
